import {useSearchOptions} from "../../../hooks/useSearchOptions";
import {groupListURL} from "./groupsTable.constants";

export const useGroupsTableSearchOptions = () => {
  const options = useSearchOptions(groupListURL, ["name"]);

  const searchOptions = [
    {
      category: {label: "Name", value: "name"},
      operator: ["=", "contains"],
      isAllowCustomValue: true,
      options: options.name,
    },
  ];

  return {searchOptions};
};
